import { render, staticRenderFns } from "./CourseDirection.vue?vue&type=template&id=214c3400&scoped=true&"
import script from "./CourseDirection.vue?vue&type=script&lang=js&"
export * from "./CourseDirection.vue?vue&type=script&lang=js&"
import style0 from "./CourseDirection.vue?vue&type=style&index=0&id=214c3400&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c3400",
  null
  
)

export default component.exports